import React from "react";

const CalendarDate = ({date}) => {
	let month = '';
	switch(date.substr(5,2)) {
		case "01":
			month = "Ene";
			break;
		case "02":
			month = "Feb";
			break;
		case "03":
			month = "Mar";
			break;
		case "04":
			month = "Abr";
			break;
		case "05":
			month = "May";
			break;
		case "06":
			month = "Jun";
			break;
		case "07":
			month = "Jul";
			break;
		case "08":
			month = "Ago";
			break;
		case "09":
			month = "Sep";
			break;
		case "10":
			month = "Oct";
			break;
		case "11":
			month = "Nov";
			break;
		case "12":
			month = "Dic";
			break;
		default:
			month = "Ene";
			break;
	};

	return (<div className="calendar-date">
		<p>
			<span className="month">{month}</span>
			<span className="day">{date.substr(8,2)}</span>
			<span className="year">{date.substr(0,4)}</span>
		</p>
	</div>)
}

export default CalendarDate;


// WEBPACK FOOTER //
// ./src/cdm-frontend/elements/widgets/calendar-date.jsx